import { useEffect } from 'react';
import { connect } from 'react-redux';

import { ReceptionLoader } from 'src/components/ReceptionLoader';
import layoutWrapper from 'src/hocs/layoutWrapper';
import { atStart } from 'src/store/flow_ng';
import { useAppDispatch } from 'src/store/hooks';

const FlowStart = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(atStart());
  }, [dispatch]);
  return null;
};

const FlowStartConnected = layoutWrapper(connect()(FlowStart), {
  headerType: 'HIDE_NAV',
  footerType: 'NONE',
  hideHeaderMobile: true,
});

const FlowStartWrapped = () => (
  <ReceptionLoader>
    <FlowStartConnected />
  </ReceptionLoader>
);

export default FlowStartWrapped;
